<template>
  <div>
    <v-btn color="primary" flat :disabled="disabled" @click="setupCamera" icon> <v-icon>add_a_photo</v-icon></v-btn>
    <SimpleTextPopup 
      :rightMethod="capturePhoto" 
      :rightButtonText="'Take photo'"
      v-model="isShowPhotoPopup"
      v-if="isShowPhotoPopup"
      ref="simpleTextPopup"
      medium
      @popupClose="() => this.isShowPhotoPopup = false"
      >
      <template v-slot:input>
        <v-layout justify-center>
          <video ref="video" width="80%" autoplay></video>
        </v-layout>
        <canvas ref="canvas" style="display: none"></canvas>
      </template>
    </SimpleTextPopup>
  </div>
</template>

<script>
import SimpleTextPopup from './SimpleTextPopup.vue'
export default {
  name: 'CameraUploadWidget',
  components: {
    SimpleTextPopup
  },
  data () {
    return {
      photoURL: '',
      isShowPhotoPopup: false,
      stream: null
    }
  },
  watch: {
    isShowPhotoPopup (val) {
      if (!val && this.stream) {
        const tracks = this.stream.getTracks()
        tracks.forEach((track) => track.stop())
        this.stream = null
      }
    }
  },
  methods: {
    async setupCamera () {
      try {
        this.stream = await navigator.mediaDevices.getUserMedia({ video: true, facingMode: 'environment' })
        this.isShowPhotoPopup = true
        this.$nextTick(() => {
          this.$refs.video.srcObject = this.stream
        })
      } catch (error) {
        this.$store.dispatch('showToast', { type: 'error', message: 'Camera authorization failed: ' + error })
      }
    },
    capturePhoto () {
      const video = this.$refs.video
      const canvas = this.$refs.canvas
      const context = canvas.getContext('2d')
      canvas.width = video.videoWidth
      canvas.height = video.videoHeight
      context.drawImage(video, 0, 0, canvas.width, canvas.height)
      canvas.toBlob((blob) => {
        const file = new File([blob], `${Math.random().toString(36).slice(2)}.png`, { type: 'image/png' })
        this.$emit('capturePhoto', file)
      }, 'image/png')
    }
  },
  props: {
    disabled: Boolean
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CameraUploadWidget.vue